(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hassell-cow-funnel-hub"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll("[data-hcc-cow-hub]").forEach((root) => {
    if (root.dataset.initialized === "true") return;
    root.dataset.initialized = "true";

    const track = root.querySelector("[data-hub-track]");
    const cards = [...root.querySelectorAll("[data-hub-card]")];
    const dots = [...root.querySelectorAll("[data-hub-dot]")];
    const current = root.querySelector("[data-hub-current]");
    const position = root.querySelector("[data-hub-position]");
    const activeTitle = root.querySelector("[data-hub-active-title]");
    const activeCopy = root.querySelector("[data-hub-active-copy]");
    const activeLink = root.querySelector("[data-hub-active-link]");
    const copy = {
      quarter: "Start with 99 listed pounds and see every cut before you move to extras.",
      half: "Open 179 listed pounds of the current recipe, then decide whether you want extras.",
      whole: "See the complete 354-pound current recipe before you build the rest of your order."
    };
    let activeIndex = 0;

    const activate = (index, scroll = false) => {
      const next = Math.max(0, Math.min(cards.length - 1, index));
      const card = cards[next];
      const key = card.dataset.hubCard;
      activeIndex = next;
      cards.forEach((item, itemIndex) => item.classList.toggle("is-active", itemIndex === next));
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === next;
        dot.classList.toggle("is-active", active);
        dot.setAttribute("aria-selected", String(active));
      });
      current.textContent = card.dataset.title;
      position.textContent = `${next + 1} of ${cards.length}`;
      activeTitle.textContent = card.dataset.title;
      activeCopy.textContent = copy[key];
      activeLink.href = card.querySelector("[data-hub-cta]").href;
      activeLink.innerHTML = `See the ${card.dataset.title} <span aria-hidden="true">→</span>`;
      if (scroll) card.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
      window.dataLayer?.push({ event: "cow_share_selector_change", cow_share: key, funnel_step: 1 });
    };

    root.querySelector("[data-hub-prev]").addEventListener("click", () => activate(activeIndex - 1, true));
    root.querySelector("[data-hub-next]").addEventListener("click", () => activate(activeIndex + 1, true));
    dots.forEach((dot) => dot.addEventListener("click", () => activate(Number(dot.dataset.hubDot), true)));
    cards.forEach((card, index) => {
      card.addEventListener("mouseenter", () => activate(index));
      card.addEventListener("focusin", () => activate(index));
      card.querySelector("[data-hub-cta]").addEventListener("click", () => {
        window.dataLayer?.push({ event: "cow_share_cta_click", cow_share: card.dataset.hubCard, funnel_step: 1 });
      });
    });

    let scrollTimer;
    track.addEventListener("scroll", () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        const center = track.getBoundingClientRect().left + track.clientWidth / 2;
        const nearest = cards.reduce((best, card, index) => {
          const rect = card.getBoundingClientRect();
          const distance = Math.abs(rect.left + rect.width / 2 - center);
          return distance < best.distance ? { index, distance } : best;
        }, { index: 0, distance: Infinity });
        activate(nearest.index);
      }, 80);
    }, { passive: true });

    window.dataLayer?.push({ event: "cow_funnel_view", funnel_step: 1, funnel_page: "share-selector" });
    activate(0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hassell-cow-shares"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll("[data-hcc-cow-root]").forEach((root) => {
    if (root.dataset.initialized === "true") return;
    root.dataset.initialized = "true";

    const money = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD"
    });
    const shareCards = [...root.querySelectorAll("[data-share-card]")];
    const shareButtons = [...root.querySelectorAll("[data-share-select]")];
    const recipeButtons = [...root.querySelectorAll("[data-recipe-select]")];
    const recipePanels = [...root.querySelectorAll("[data-recipe-panel]")];
    const recipeTitle = root.querySelector("[data-recipe-title]");
    const recipeStatus = root.querySelector("[data-recipe-status]");
    const dialog = root.querySelector("[data-review-dialog]");
    const searchInput = root.querySelector("[data-addon-search]");
    const searchClear = root.querySelector("[data-addon-search-clear]");
    const searchStatus = root.querySelector("[data-addon-search-status]");
    const searchResults = root.querySelector("[data-addon-search-results]");
    const addonFeedback = root.querySelector("[data-addon-feedback]");
    const selectedRegion = root.querySelector("[data-summary-selected]");
    const selectedList = root.querySelector("[data-summary-selected-list]");
    const cartButton = root.querySelector("[data-cart-submit]");
    const cartStatus = root.querySelector("[data-cart-status]");
    const cutVideos = [...root.querySelectorAll("[data-cow-cut-video]")];
    const eligibleAddonVariantIds = new Set([
      "29571331719254", "44127147622699", "47110504448299", "31955821166678",
      "29571363110998", "50927674327339", "50927674360107", "44526831075627",
      "44526831108395", "44526831141163", "47974904103211", "29570885746774",
      "47974913409323", "39642241499222", "39716199792726", "44590389723435",
      "29583151693910", "29570891874390", "49399113613611", "50151727005995",
      "39494874398806", "39494874366038", "47763945455915", "50151735230763",
      "50098564071723", "50098564104491", "39732480639062", "48835688005931",
      "44693336817963", "39494721798230", "47763986612523", "44693336785195",
      "50098534318379", "50098534351147", "50098534383915", "50098537857323",
      "50098537890091", "50098537922859", "39716190093398", "50910844059947",
      "39468900646998", "39547102593110", "49442477998379", "31356183806038",
      "48835725197611", "50517929230635", "44693939388715", "44693939355947",
      "47763286065451", "39677050093654", "50151789232427"
    ]);
    const selectedAddons = new Map();
    const productCache = new Map();
    const shopRoot = window.Shopify?.routes?.root || "/";
    const checkoutEnabled = root.dataset.checkoutEnabled === "true";
    let selectedShare = root.dataset.initialShare || "quarter";
    let searchController;
    let searchTimer;

    cutVideos.forEach((video) => {
      video.addEventListener("play", () => {
        cutVideos.forEach((otherVideo) => {
          if (otherVideo !== video && !otherVideo.paused) otherVideo.pause();
        });
        window.dataLayer?.push({
          event: "cow_cut_gallery_play",
          cow_share: selectedShare,
          cut_name: video.getAttribute("aria-label") || "cow-share-cut"
        });
      });
    });

    const cutSlides = [...root.querySelectorAll("[data-cut-slide]")];
    const activateCut = (slide) => {
      cutSlides.forEach((item) => item.classList.toggle("is-active", item === slide));
      cutSlides.forEach((item) => {
        if (item !== slide) item.querySelector("video")?.pause();
      });
    };
    cutSlides.forEach((slide) => {
      slide.addEventListener("mouseenter", () => activateCut(slide));
      slide.addEventListener("focusin", () => activateCut(slide));
      slide.addEventListener("click", () => activateCut(slide));
    });

    const setFunnelStep = (step, updateHash = true) => {
      if (!root.classList.contains("hcc-cow--funnel-detail")) return;
      const next = step === "extras" ? "extras" : "detail";
      root.dataset.funnelStep = next;
      root.querySelectorAll("[data-funnel-go]").forEach((control) => {
        const active = control.dataset.funnelGo === next;
        control.classList.toggle("is-active", active);
        if (active) control.setAttribute("aria-current", "step");
        else control.removeAttribute("aria-current");
      });
      if (updateHash) history.replaceState(null, "", next === "extras" ? "#extras" : location.pathname + location.search);
      const target = next === "extras"
        ? root.querySelector('[data-funnel-panel="extras"]')
        : root.querySelector('[data-funnel-panel="detail"]');
      target?.scrollIntoView({ behavior: "smooth", block: "start" });
      window.dataLayer?.push({ event: "cow_share_detail_step", cow_share: selectedShare, funnel_step: next === "extras" ? 3 : 2 });
    };
    root.querySelectorAll("[data-funnel-go]").forEach((control) => {
      control.addEventListener("click", () => setFunnelStep(control.dataset.funnelGo));
    });
    if (location.hash === "#extras") setFunnelStep("extras", false);

    root.querySelectorAll("[data-addon-select]").forEach((button) => {
      if (eligibleAddonVariantIds.has(button.dataset.addonKey)) return;
      button.disabled = true;
      button.textContent = "Not eligible for this offer";
      button.setAttribute("aria-label", `${button.dataset.addonTitle} is not eligible for the current cow-share add-on offer`);
    });

    const shareData = () => {
      const card = root.querySelector(`[data-share-card="${selectedShare}"]`);
      return {
        title: card.dataset.shareTitle,
        price: Number(card.dataset.sharePrice),
        variantId: card.dataset.shareVariantId
      };
    };

    const addonData = () => [...selectedAddons.values()];

    const syncAddonControls = (key) => {
      const active = selectedAddons.has(key);
      root.querySelectorAll("[data-addon-select]").forEach((button) => {
        if (button.dataset.addonKey !== key) return;
        button.setAttribute("aria-pressed", String(active));
        button.textContent = active ? "Added" : button.dataset.addonDefaultLabel || "Add extra";
        button.setAttribute(
          "aria-label",
          active ? `Remove ${button.dataset.addonTitle} from selection` : `Add ${button.dataset.addonTitle} to selection`
        );
        const variantSelect = button.closest("[data-search-result-card]")?.querySelector("[data-search-variant]");
        if (variantSelect) variantSelect.disabled = active;
      });
    };

    const renderSelectedAddons = (addons) => {
      selectedList.replaceChildren();
      selectedRegion.hidden = addons.length === 0;

      addons.forEach((addon) => {
        const button = document.createElement("button");
        button.type = "button";
        button.dataset.addonRemove = addon.key;
        button.setAttribute("aria-label", `Remove ${addon.title}`);
        button.textContent = `${addon.title} ×`;
        selectedList.append(button);
      });
    };

    const updateSummary = () => {
      const share = shareData();
      const addons = addonData();
      const addonPrice = addons.reduce((sum, addon) => sum + addon.price, 0);
      const addonRetail = addons.reduce((sum, addon) => sum + addon.retail, 0);
      const addonTitles = addons.length ? addons.map((addon) => addon.title).join(", ") : "None selected";
      const total = share.price + addonPrice;

      root.querySelector("[data-summary-share]").textContent = share.title;
      root.querySelector("[data-summary-share-price]").textContent = money.format(share.price / 100);
      root.querySelector("[data-summary-addons]").textContent = addonTitles;
      root.querySelector("[data-summary-addon-price]").textContent = money.format(addonPrice / 100);
      root.querySelector("[data-summary-savings]").textContent = money.format((addonRetail - addonPrice) / 100);
      root.querySelector("[data-summary-total]").textContent = money.format(total / 100);
      root.querySelector("[data-dialog-title]").textContent = share.title;
      root.querySelector("[data-dialog-share-price]").textContent = money.format(share.price / 100);
      root.querySelector("[data-dialog-addons]").textContent = addonTitles;
      root.querySelector("[data-dialog-addon-price]").textContent = money.format(addonPrice / 100);
      root.querySelector("[data-dialog-total]").textContent = money.format(total / 100);
      renderSelectedAddons(addons);
    };

    const renderShare = (key) => {
      selectedShare = key;
      shareCards.forEach((card) => card.classList.toggle("is-selected", card.dataset.shareCard === key));
      shareButtons.forEach((button) => {
        const active = button.dataset.shareSelect === key;
        const shareTitle = root.querySelector(`[data-share-card="${button.dataset.shareSelect}"]`).dataset.shareTitle;
        button.setAttribute("aria-pressed", String(active));
        button.setAttribute("aria-label", active ? `${shareTitle} selected` : `Choose ${shareTitle}`);
        button.textContent = active
          ? `${shareTitle} selected`
          : `Choose ${button.dataset.shareSelect.charAt(0).toUpperCase()}${button.dataset.shareSelect.slice(1)}`;
      });
      recipeButtons.forEach((button) => button.setAttribute("aria-pressed", String(button.dataset.recipeSelect === key)));
      recipePanels.forEach((panel) => {
        const active = panel.dataset.recipePanel === key;
        panel.hidden = !active;
        panel.classList.toggle("is-active", active);
        const fullList = panel.querySelector(".hcc-cow__full-list");
        if (fullList) fullList.open = active;
      });
      recipeTitle.textContent = `${shareData().title}: every cut, counted.`;
      recipeStatus.textContent = `${shareData().title} selected. Recipe updated below.`;
      updateSummary();
    };

    const selectShare = (key) => {
      renderShare(key);
    };

    shareButtons.forEach((button) => button.addEventListener("click", () => selectShare(button.dataset.shareSelect)));
    recipeButtons.forEach((button) => button.addEventListener("click", () => selectShare(button.dataset.recipeSelect)));

    const toggleAddon = (button) => {
      const key = button.dataset.addonKey;
      if (!key || button.disabled) return;

      if (!eligibleAddonVariantIds.has(key)) {
        addonFeedback.textContent = "That exact variant is not part of the current cow-share add-on offer.";
        return;
      }

      addonFeedback.textContent = "";
      if (selectedAddons.has(key)) {
        selectedAddons.delete(key);
      } else {
        if (selectedAddons.size >= 3) {
          addonFeedback.textContent = "You can choose up to three extra cuts. Remove one before adding another.";
          return;
        }

        selectedAddons.set(key, {
          key,
          title: button.dataset.addonTitle,
          price: Number(button.dataset.addonPrice),
          retail: Number(button.dataset.addonRetail)
        });
      }

      syncAddonControls(key);
      updateSummary();
    };

    const eligibleProduct = (product) => {
      const tags = Array.isArray(product.tags) ? product.tags.map((tag) => String(tag).trim().toLowerCase()) : [];
      const searchableName = `${product.title || ""} ${product.type || ""}`.toLowerCase();
      const excluded = /(bundle|box|cow|carcass|sampler|subscription|membership|table club|gift|tallow|seasoning|sauce|jerky|snack|stick|dog|merch|shirt|hat)/;
      return Boolean(product.available) && tags.includes("meat inventory") && !excluded.test(searchableName);
    };

    const fetchExactProduct = async (handle, signal) => {
      if (productCache.has(handle)) return productCache.get(handle);
      const response = await fetch(`${shopRoot}products/${encodeURIComponent(handle)}.js`, {
        headers: { Accept: "application/json" },
        signal
      });
      if (!response.ok) throw new Error(`Product lookup failed with ${response.status}`);
      const product = await response.json();
      productCache.set(handle, product);
      return product;
    };

    const makeSearchCard = (product) => {
      const variants = (product.variants || []).filter(
        (variant) => variant.available && eligibleAddonVariantIds.has(String(variant.id))
      );
      if (variants.length === 0) return null;

      const card = document.createElement("article");
      card.className = "hcc-cow__addon-card hcc-cow__search-card";
      card.setAttribute("role", "listitem");
      card.dataset.searchResultCard = "";

      const imageWrap = document.createElement("div");
      imageWrap.className = "hcc-cow__addon-image";
      const image = document.createElement("img");
      image.loading = "lazy";
      image.alt = product.title;
      image.src = product.featured_image || product.images?.[0] || "";
      if (image.src) imageWrap.append(image);
      const offerBadge = document.createElement("span");
      offerBadge.textContent = "15% off with a cow share";
      imageWrap.append(offerBadge);

      const body = document.createElement("div");
      body.className = "hcc-cow__addon-body";
      const type = document.createElement("span");
      type.textContent = product.type || "Individual cut";
      const title = document.createElement("h3");
      title.textContent = product.title;
      const help = document.createElement("p");
      help.textContent = variants.length > 1 ? "Choose the exact available variant." : "Available now in the live catalog.";

      const variantField = document.createElement("label");
      variantField.className = "hcc-cow__variant-field";
      const variantLabel = document.createElement("span");
      variantLabel.textContent = variants.length > 1 ? "Choose variant" : "Available variant";
      const variantSelect = document.createElement("select");
      variantSelect.dataset.searchVariant = "";
      variants.forEach((variant) => {
        const option = document.createElement("option");
        option.value = String(variant.id);
        option.textContent = variant.title.toLowerCase() === "default title"
          ? money.format(Number(variant.price) / 100)
          : `${variant.title} · ${money.format(Number(variant.price) / 100)}`;
        variantSelect.append(option);
      });
      if (variants.length === 1) variantSelect.hidden = true;
      variantField.append(variantLabel, variantSelect);
      if (variants.length === 1) variantField.hidden = true;

      const prices = document.createElement("div");
      prices.className = "hcc-cow__addon-prices";
      const retailPrice = document.createElement("span");
      const cowPrice = document.createElement("strong");
      prices.append(retailPrice, cowPrice);

      const button = document.createElement("button");
      button.type = "button";
      button.className = "hcc-cow__button hcc-cow__button--addon";
      button.dataset.addonDefaultLabel = "Add extra";
      button.setAttribute("aria-pressed", "false");

      const applyVariant = (variant) => {
        const key = String(variant.id);
        const retail = Number(variant.price);
        const discounted = retail - Math.floor(retail * .15);
        const variantTitle = String(variant.title || "").trim();
        const addonTitle = variantTitle && variantTitle.toLowerCase() !== "default title"
          ? `${product.title} — ${variantTitle}`
          : product.title;

        button.dataset.addonSelect = `search-${key}`;
        button.dataset.addonKey = key;
        button.dataset.addonTitle = addonTitle;
        button.dataset.addonPrice = String(discounted);
        button.dataset.addonRetail = String(retail);
        retailPrice.textContent = money.format(retail / 100);
        cowPrice.textContent = money.format(discounted / 100);
        const active = selectedAddons.has(key);
        button.setAttribute("aria-pressed", String(active));
        button.textContent = active ? "Added" : button.dataset.addonDefaultLabel;
        button.setAttribute("aria-label", active ? `Remove ${addonTitle} from selection` : `Add ${addonTitle} to selection`);
        variantSelect.disabled = active;
        syncAddonControls(key);
      };

      variantSelect.addEventListener("change", () => {
        const variant = variants.find((item) => String(item.id) === variantSelect.value);
        if (variant) applyVariant(variant);
      });

      applyVariant(variants[0]);
      body.append(type, title, help, variantField, prices, button);
      card.append(imageWrap, body);
      return card;
    };

    const showSearchEmpty = (message) => {
      const empty = document.createElement("p");
      empty.className = "hcc-cow__search-empty";
      empty.textContent = message;
      searchResults.replaceChildren(empty);
      searchResults.hidden = false;
      root.classList.remove("is-search-results");
    };

    const resetSearch = () => {
      if (searchController) searchController.abort();
      clearTimeout(searchTimer);
      searchResults.replaceChildren();
      searchResults.hidden = true;
      searchResults.setAttribute("aria-busy", "false");
      root.classList.remove("is-search-results");
      searchStatus.textContent = "Search by cut or size. Available individual cuts appear here.";
    };

    const searchCatalog = async (query) => {
      if (searchController) searchController.abort();
      searchController = new AbortController();
      const { signal } = searchController;
      searchResults.replaceChildren();
      searchResults.hidden = true;
      searchResults.setAttribute("aria-busy", "true");
      root.classList.remove("is-search-results");
      searchStatus.textContent = `Searching available cuts for “${query}”…`;

      const parameters = new URLSearchParams();
      parameters.set("q", query);
      parameters.set("resources[type]", "product");
      parameters.set("resources[limit]", "8");
      parameters.set("resources[options][unavailable_products]", "hide");
      parameters.set("resources[options][fields]", "title,product_type,variants.title,variants.sku");

      try {
        const response = await fetch(`${shopRoot}search/suggest.json?${parameters}`, {
          headers: { Accept: "application/json" },
          signal
        });
        if (!response.ok) throw new Error(`Search failed with ${response.status}`);
        const suggestions = await response.json();
        const products = (suggestions.resources?.results?.products || []).filter(eligibleProduct);
        const exactResults = await Promise.allSettled(
          products.map((product) => fetchExactProduct(product.handle, signal))
        );
        if (signal.aborted) return;

        const exactProducts = exactResults
          .filter((result) => result.status === "fulfilled")
          .map((result) => result.value)
          .filter((product) => (product.variants || []).some((variant) => variant.available));
        const cards = exactProducts.map(makeSearchCard).filter(Boolean);
        searchResults.setAttribute("aria-busy", "false");

        if (cards.length === 0) {
          showSearchEmpty(`No available individual cuts matched “${query}”. Try another cut name.`);
          searchStatus.textContent = `No available individual cuts found for “${query}”.`;
          return;
        }

        const fragment = document.createDocumentFragment();
        cards.forEach((card) => fragment.append(card));
        searchResults.replaceChildren(fragment);
        searchResults.hidden = false;
        root.classList.add("is-search-results");
        searchStatus.textContent = `${cards.length} ${cards.length === 1 ? "cut" : "cuts"} found for “${query}”. Choose an exact variant, then add it.`;
      } catch (error) {
        if (error.name === "AbortError") return;
        searchResults.setAttribute("aria-busy", "false");
        showSearchEmpty("The cut search is temporarily unavailable. The three popular extras below still work.");
        searchStatus.textContent = "Cut search temporarily unavailable.";
      }
    };

    const queueSearch = () => {
      const query = searchInput.value.trim();
      searchClear.hidden = query.length === 0;
      clearTimeout(searchTimer);

      if (query.length < 2) {
        resetSearch();
        if (query.length === 1) searchStatus.textContent = "Type one more letter to search available cuts.";
        return;
      }

      searchTimer = setTimeout(() => searchCatalog(query), 260);
    };

    searchInput.addEventListener("input", queueSearch);

    root.querySelector("[data-review-open]").addEventListener("click", () => {
      updateSummary();
      cartStatus.textContent = "";
      dialog.showModal();
    });

    cartButton.addEventListener("click", async () => {
      if (!checkoutEnabled || cartButton.disabled) return;

      const share = shareData();
      const items = [
        { id: Number(share.variantId), quantity: 1 },
        ...addonData().map((addon) => ({ id: Number(addon.key), quantity: 1 }))
      ];

      cartButton.disabled = true;
      cartButton.setAttribute("aria-busy", "true");
      cartButton.textContent = "Adding to cart…";
      cartStatus.textContent = "Adding your cow share and selected cuts to the cart.";

      try {
        const response = await fetch(`${shopRoot}cart/add.js`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || error.message || `Cart request failed with ${response.status}`);
        }

        cartStatus.textContent = "Added. Opening your cart…";
        window.location.assign(`${shopRoot}cart`);
      } catch (error) {
        cartStatus.textContent = error.message || "We could not add this selection. Please try again.";
        cartButton.disabled = false;
        cartButton.removeAttribute("aria-busy");
        cartButton.textContent = "Add to cart";
      }
    });

    root.addEventListener("click", (event) => {
      const removeButton = event.target.closest("[data-addon-remove]");
      if (removeButton && root.contains(removeButton)) {
        const key = removeButton.dataset.addonRemove;
        selectedAddons.delete(key);
        syncAddonControls(key);
        addonFeedback.textContent = "";
        updateSummary();
        return;
      }

      const suggestion = event.target.closest("[data-addon-search-suggestion]");
      if (suggestion && root.contains(suggestion)) {
        searchInput.value = suggestion.dataset.addonSearchSuggestion;
        queueSearch();
        searchInput.focus();
        return;
      }

      const clearButton = event.target.closest("[data-addon-search-clear]");
      if (clearButton && root.contains(clearButton)) {
        searchInput.value = "";
        searchClear.hidden = true;
        resetSearch();
        searchInput.focus();
        return;
      }

      const addonButton = event.target.closest("[data-addon-select]");
      if (addonButton && root.contains(addonButton)) toggleAddon(addonButton);
    });

    renderShare(selectedShare);
  });

  } catch(e) { console.error(e); }
})();
})();
